<button (click)="loginSalesForce()" class="btn btn-block w-100 fw-bold">
  {{ 'login.page.button.text' | translate }}
</button>
